import EndPointConfig from "src/models/api/endPointConfig";

const controller = 'academyconfiguration';

/// Define all EndPoints for Client Data.
export const AcademyConfigurationEP: EndPointConfig[] = [
    new EndPointConfig().setMethod("GET").setController(controller).setActionName('config').setAlias("GetAcademyConfig"),

];

